'use client';

import { createCache, extractStyle, StyleProvider } from '@ant-design/cssinjs';
import { useServerInsertedHTML } from 'next/navigation';
import React from 'react';

const StyledComponentsRegistry = ({ children }: { children: React.ReactNode }) => {
  const [cache] = React.useState(() => createCache());
  const inserted = React.useRef(false);

  useServerInsertedHTML(() => {
    if (inserted.current) return null;

    const css = extractStyle(cache, true);
    inserted.current = true;

    return <style id="antd" dangerouslySetInnerHTML={{ __html: css }} />;
  });

  return <StyleProvider cache={cache}>{children}</StyleProvider>;
};

export default StyledComponentsRegistry;
